/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Sla_WarningInputs */

const vi_notif_type_sla_warning = /** @type {(inputs: Notif_Type_Sla_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảnh báo quá hạn`)
};

/**

* @param {Notif_Type_Sla_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_sla_warning = /** @type {((inputs?: Notif_Type_Sla_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Sla_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_sla_warning(inputs)
});